export default "__VITE_ASSET__Bx4CQBy1__"